define.alias("shared/components/shared/restricted-area/modal", "media/components/shared/restricted-area/modal");